import React from "react";
import Editor from "@monaco-editor/react";
export class CodeEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || ''
        };
    }
    componentWillReceiveProps(props) {
        this.setState({
            value: props.value || ''
        });
    }
    render() {
        return React.createElement("div", { style: { border: 'solid 1px #0078d4', boxShadow: '0px 0px 3px 1px #0078d4', height: '100%' } },
            React.createElement(Editor, { height: this.props.height || 'calc(100% - 20px)', defaultLanguage: this.props.language, value: this.state.value || '', onChange: this.props.onChanged, onMount: (editor, monaco) => {
                    editor.addAction({
                        id: 'insert-component',
                        label: 'Insert ProcesoX Component',
                        keybindings: [
                            monaco.KeyMod.CtrlCmd | monaco.KeyCode.F10,
                            // chord
                            monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyK, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyM)
                        ],
                        contextMenuGroupId: 'navigation',
                        contextMenuOrder: 1.5,
                        run: () => {
                        }
                    });
                    if (this.props.onMount != null) {
                        this.props.onMount(editor, monaco);
                    }
                }, options: { fontSize: 16 } }));
    }
}
